import {
  useGetUserSettingsQuery,
  useUpdateUserSettingsMutation,
} from '@carboncopyco/data';
import type { DataOptions } from '@carboncopyco/types';
import {
  PositionedToggle,
  TextBase,
  TextLedeOpening,
  notify,
} from '@carboncopyco/ui';
import { removeUndefinedValues } from '@carboncopyco/utils';
import { useParams } from 'react-router-dom';

export const EmailNotifications = () => {
  const { organizationId } = useParams();
  const [updateNotificationsSettings] = useUpdateUserSettingsMutation();
  const { data: notificationsSettings } = useGetUserSettingsQuery({
    organizationId,
  });
  const emailNotifications = notificationsSettings?.emailNotification;

  const toggleOption = (option: DataOptions) => {
    const optionsObject = Object.fromEntries(
      emailNotifications.dataCoverage.options.map((opt) => [opt, true])
    );
    optionsObject[option] = !optionsObject[option];

    updateNotificationsSettings({
      ...notificationsSettings,
      emailNotification: {
        ...emailNotifications,
        dataCoverage: {
          ...emailNotifications?.dataCoverage,
          options: Object.keys(
            removeUndefinedValues(optionsObject)
          ) as DataOptions[],
        },
      },
    })
      .unwrap()
      .catch(() => {
        notify.error("Settings didn't update. Please try again.");
      });
  };

  return (
    notificationsSettings && (
      <div className="flex flex-col ">
        <div className="flex flex-col gap-2.5 mb-6">
          <TextLedeOpening
            label="Email notifications"
            color="text-ds-natural-600"
          />
          <TextBase
            label="Get an email every time:"
            color="text-ds-natural-600"
          />
        </div>
        <div className="flex flex-col gap-2.5">
          <div className="flex items-center gap-2">
            <PositionedToggle
              checked={emailNotifications.dataCoverage.options.some(
                (option: DataOptions) => option === 'tour'
              )}
              name="tour"
              onChange={() => {
                toggleOption('tour');
              }}
            />
            <TextBase
              label="Your shared tour gets a visit"
              color="text-ds-natural-600"
            />
          </div>
          <div className="flex items-center gap-2">
            <PositionedToggle
              checked={emailNotifications.dataCoverage.options.some(
                (option: DataOptions) => option === 'sandbox'
              )}
              name="sandbox"
              onChange={() => toggleOption('sandbox')}
            />
            <TextBase
              label="Your shared sandbox gets a visit"
              color="text-ds-natural-600"
            />
          </div>
          <div className="flex items-center gap-2">
            <PositionedToggle
              checked={emailNotifications.dataCoverage.options.some(
                (option: DataOptions) => option === 'demo'
              )}
              name="demo"
              onChange={() => toggleOption('demo')}
            />
            <TextBase
              label="Your presentation is showcased"
              color="text-ds-natural-600"
            />
          </div>
        </div>
      </div>
    )
  );
};
